import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Col, Form, FormGroup, Input, Label, Row, Tooltip } from "reactstrap";
import SikkaInput from "../../common/SikkaInput";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import SikkaError from "../../common/SikkaError";
import LoadingButton from "../../common/LoadingButton";
import { Button } from "react-bootstrap";
import { Nav, NavItem, NavLink, Tab } from "react-bootstrap";
import creditCard from "../../../assets/img/icons/icon-payment-methods.png";
import CreditPaymentForm from "./CreditPaymentForm";
import { faLeftLong } from "@fortawesome/free-solid-svg-icons";
import AchPaymentForm from "./AchPaymentForm";
import axios from "axios";
import authenticationService from "../../../services/authenticationService";
import withRedirect from "../../../hoc/withRedirect";
import { toast } from "react-toastify";
import { useLocation } from "react-router";
import AuthService from "../../../services/authenticationService";
import ReferralCode from "../../common/ReferralCode";

const hostName = (url) => {
  if (url.includes("localhost")) {
    return "localhost";
  } else if (url.includes("qa")) {
    return "qa";
  } else {
    return "production";
  }
};

const RegisterPayment = ({
  step,
  setStep,
  registerFormValues,
  setRedirect,
  setRedirectUrl,
  setPaymentFormValues,
  paymentFormValues,
}) => {
  const defaultKey = paymentFormValues?.last_default_key
    ? paymentFormValues?.last_default_key
    : "credit";
  const [defaultActiveKey, setDefaultActiveKey] = useState(defaultKey);

  const [formValues, setFormValues] = useState(paymentFormValues);
  const creditCardRef = useRef();
  const achCardRef = useRef();
  const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
  const [referralCode, setReferralCode] = useState(formValues["referralCode"] || "");
  const isApiPlusExist = sessionStorage.getItem("api_plus_plus")
        ? JSON.parse(sessionStorage.getItem("api_plus_plus"))
        : false;
  const {
    register,
    errors,
    watch,
    handleSubmit,
    reset,
    control,
    setValue,
    setError,
    clearError,
  } = useForm();

  const watchLiveData = watch();
  const liveWatch = JSON.stringify(Object.values(watchLiveData));
  const outSideFields = [
    "address",
    "zip",
    "state",
    "city",
    "email_id",
    "first_name",
    "last_name",
  ];

  useEffect(() => {
    if (isApiPlusExist) {
      outSideFields.map((item)=>{
        const getKey = Object.keys(registerFormValues);
        const makeKey = getKey.includes(item) ? item : `dev_${item}`;
        const keyValue = registerFormValues[makeKey];
        
        setValue(item,keyValue);
      });
    }
  }, [registerFormValues])

  useEffect(() => {
    if (isApiPlusExist) {
      setPaymentFormValues({...paymentFormValues,referralCode:referralCode});
    }
  }, [referralCode])
  

  useEffect(() => {
    const getKeys = formValues[defaultActiveKey]
      ? Object.keys(formValues[defaultActiveKey]).filter((item) =>
          item.includes(defaultActiveKey)
        )
      : [];

    let tempObject = {};

    getKeys.map((item) => {
      tempObject = {
        ...tempObject,
        [item]: paymentFormValues[defaultActiveKey][item],
      };
    });

    let userRegionDetails = {};
    outSideFields.map((item) => {
      userRegionDetails = {
        ...userRegionDetails,
        [item]: paymentFormValues[item],
      };
    });

    const combinedObject = { ...tempObject, ...userRegionDetails };

    if (defaultActiveKey == "credit") {
      reset(combinedObject);
    }

    if (defaultActiveKey == "ach") {
      reset(combinedObject);
    }
  }, [defaultActiveKey]);

  useEffect(() => {
    let userRegionDetails = {};
    outSideFields.map((item) => {
      userRegionDetails = { ...userRegionDetails, [item]: watchLiveData[item] };
    });

    if (defaultActiveKey == "ach") {
      setPaymentFormValues({
        ...paymentFormValues,
        [defaultActiveKey]: watchLiveData,
        last_default_key: defaultActiveKey,
        ...userRegionDetails,
      });
    }
    if (defaultActiveKey == "credit") {
      setPaymentFormValues({
        ...paymentFormValues,
        [defaultActiveKey]: watchLiveData,
        last_default_key: defaultActiveKey,
        ...userRegionDetails,
      });
    }

    setFormValues({
      ...formValues,
      [defaultActiveKey]: watchLiveData,
      last_default_key: defaultActiveKey,
    });
  }, [liveWatch]);
  const useQuery = () => {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  };

  const query = useQuery();

  const isApiPlusPlus =
      query.get("request") == "apiplusplus" &&
      query.get("callback_key") &&
      query.get("redirect_url");
      
  const HandlePaymentCardForm = (values) => {
    let body = {
      username: registerFormValues?.username,
      password: registerFormValues?.password,
      dev_name: registerFormValues?.dev_name,
      dev_address: registerFormValues?.dev_address,
      dev_phone: registerFormValues?.dev_phone,
      dev_mobile: registerFormValues?.dev_mobile,
      dev_city: registerFormValues?.dev_city,
      dev_state: registerFormValues?.dev_state,
      dev_country: registerFormValues?.dev_country,
      dev_zip: registerFormValues?.dev_zip,
      dev_site_url: registerFormValues?.dev_site_url,
      dev_purpose: registerFormValues?.dev_purpose,
      plan_id: registerFormValues?.plan_id,
      referred_by: registerFormValues?.referred_by,
      partner_name: registerFormValues?.partner_name,
      page_type: "signup",
      is_vip_signup: "",
    };

    if (defaultActiveKey == "credit") {
      const dateValue = values["credit_card_expiration_date"]?.split("/");
      const monthValue = dateValue[0];
      const yearValue = dateValue[1]?.slice(2);

      setFormValues({ ...formValues, [defaultActiveKey]: values });
      body["card_details"] = {};
      body["card_details"] = {
        type_of_payment: defaultActiveKey,
        card_number: values.credit_card_number,
        expiration_date: `${monthValue}/${yearValue}`,
        address: values.address,
        state: values.state,
        city: values.city,
        zip: values.zip,
        email_id: isApiPlusExist ? registerFormValues["username"] : values.email_id?.toLowerCase(),
        first_name: values.first_name,
        last_name: values.last_name,
        cvv: values.credit_security_code,
        host: hostName(window.location.href),
      };
    }

    if (defaultActiveKey == "ach") {
      setFormValues({ ...formValues, [defaultActiveKey]: values });
      body["card_details"] = {};
      body["card_details"] = {
        type_of_payment: defaultActiveKey,
        name_on_account: values.ach_name_on_account,
        bank_name: values.ach_bank_name,
        account_number: values.ach_account_number,
        routing_number: values.ach_routing_number,
        address: values.address,
        state: values.state,
        city: values.city,
        zip: values.zip,
        email_id:isApiPlusExist ? registerFormValues["username"] : values.email_id?.toLowerCase(),
        first_name: values.first_name,
        last_name: values.last_name,
        host: hostName(window.location.href),
        account_type: "ach",
      };
    }

    setIsSubmitButtonClicked(true);
    if (isApiPlusPlus || isApiPlusExist) {
      body["redirect_url"] = query.get("redirect_url") || isApiPlusExist["redirect_url"];
      body["callback_key"] = query.get("callback_key") || isApiPlusExist["callback_key"];
      body["request"] = query.get("request") || isApiPlusExist["request"];
      body["referral_code_by"] = referralCode;
      body["project_id"] = query.get("project_id") ? query.get("project_id") || isApiPlusExist["project_id"]  : "";
      body["source_project_id"] = query.get("source_project_id") ? query.get("source_project_id") || isApiPlusExist["source_project_id"] : "";

      AuthService.register("register_api_plus", body).then(
        (res) => {
          sessionStorage.removeItem("api_plus_plus");
          sessionStorage.removeItem("pastedLinkCount");
          toast.success(res.data?.message);
          setTimeout(() => {
            window.location.href = res.data?.items?.url;
          }, 3000);
          // setRedirectUrl(`${process.env.PUBLIC_URL}/authentication/login`);
          // setRedirect(false);
          setIsSubmitButtonClicked(false);
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          setIsSubmitButtonClicked(false);
          if (
            resMessage.includes("A duplicate transaction has been submitted")
          ) {
            toast.error(
              "A duplicate transaction has been submitted. Please try again after sometime."
            );
          } else {
            toast.error(resMessage);
          }
        }
      );
    } else {
      authenticationService
        .CustomRegister(body)
        .then((response) => {
          setRedirectUrl(`${process.env.PUBLIC_URL}/authentication/login`);
          setRedirect(true);
          toast.success("User register successfully!");
          setIsSubmitButtonClicked(false);
        })
        .catch((error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          setIsSubmitButtonClicked(false);
          if (
            resMessage.includes("A duplicate transaction has been submitted")
          ) {
            toast.error(
              "A duplicate transaction has been submitted. Please try again after sometime."
            );
          } else {
            toast.error(resMessage);
          }
        });
    }
      
  };
  
  return (
    <>
      {isApiPlusExist && 
      <>
        <Row>
          <Col className="col-4">
            <Button
              size="sm"
              onClick={() => {
                if (step == 1) {
                } else {
                  setStep(1);
                }
              }}
              disabled={step == 1 || isSubmitButtonClicked}
              variant="outline-secondary"
            >
              <FontAwesomeIcon icon={faLeftLong} /> {" Back"}
            </Button>
          </Col>
          <Col>
              <p className="sai_light_text">Payment Information</p>
          </Col>
        </Row>
      </>
      }
      {isApiPlusExist && <ReferralCode setReferralCode={setReferralCode} referralCode={referralCode}/>}
      <div className="payment-types">
        <Tab.Container
          defaultActiveKey={defaultActiveKey}
          onSelect={(selectedValue) => setDefaultActiveKey(selectedValue)}
        >
          {!isApiPlusExist && <Nav variant="tabs">
            <Nav.Item>
              <Nav.Link
                eventKey="credit"
                className="fs--1 px-2 px-md-3 cursor-pointer outline-none"
              >
                Credit Card
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                eventKey="ach"
                className="fs--1 px-2 px-md-3 cursor-pointer outline-none"
              >
                ACH
              </Nav.Link>
            </Nav.Item>
          </Nav>}

          <Row className="mb-2 mt-2">
            <Col className="d-flex justify-content-center">
              <img
                src={creditCard}
                height="20"
                className=""
                alt="paypal"
                width={"auto"}
              />
            </Col>
          </Row>
          <Tab.Content>
            <Tab.Pane eventKey="credit">
              {defaultActiveKey == "credit" && (
                <>
                  <CreditPaymentForm
                    setFormValue={setFormValues}
                    register={register}
                    errors={errors}
                    watch={watch}
                    handleSubmit={handleSubmit}
                    reset={reset}
                    control={control}
                    setValue={setValue}
                    // HandlePaymentCardForm={HandlePaymentCardForm}
                    formRef={creditCardRef}
                    form_name={defaultActiveKey}
                    setError={setError}
                    clearError={clearError}
                    currentFormValue={paymentFormValues[defaultActiveKey]}
                    // setFormValue={setFormValues}
                  />
                </>
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="ach">
              {defaultActiveKey == "ach" && (
                <>
                  <AchPaymentForm
                    setFormValue={setFormValues}
                    register={register}
                    errors={errors}
                    watch={watch}
                    handleSubmit={handleSubmit}
                    reset={reset}
                    control={control}
                    setValue={setValue}
                    // HandlePaymentCardForm={HandlePaymentCardForm}
                    formRef={achCardRef}
                    form_name={defaultActiveKey}
                    setError={setError}
                    clearError={clearError}
                    // setFormValue={setFormValues}
                  />
                </>
              )}
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
      <div className="billing-information-container">
        <Row className="mt-1 mb-1">
          <Col>
            <h6>Billing Information</h6>
          </Col>
        </Row>
        <Row>
          <Col>
            <SikkaInput
              onBlur={(e) => {
                if (!e.target.value.trim()) {
                  setError(
                    e.target.name,
                    "custom",
                    `${CapitalizeString(
                      e.target.name
                    )} field should not have whitespace as value.`
                  );
                } else {
                  clearError(e.target.name);
                  setValue(e.target.name, e.target.value.trim());
                }
              }}
              label="First Name*"
              placeholder="First Name"
              id="first_name"
              name={`first_name`}
              innerRef={register({
                required: "First Name is required",
              })}
              errors={errors}
            />
          </Col>
          <Col>
            <SikkaInput
              onBlur={(e) => {
                if (!e.target.value.trim()) {
                  setError(
                    e.target.name,
                    "custom",
                    `${CapitalizeString(
                      e.target.name
                    )} field should not have whitespace as value.`
                  );
                } else {
                  clearError(e.target.name);
                  setValue(e.target.name, e.target.value.trim());
                }
              }}
              label="Last Name*"
              placeholder="Last Name"
              id="last_name"
              name={`last_name`}
              innerRef={register({
                required: "Last Name is required",
              })}
              errors={errors}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <SikkaInput
              onBlur={(e) => {
                if (!e.target.value.trim()) {
                  setError(
                    e.target.name,
                    "custom",
                    `${CapitalizeString(
                      e.target.name
                    )} field should not have whitespace as value.`
                  );
                } else {
                  clearError(e.target.name);
                  setValue(e.target.name, e.target.value.trim());
                }
              }}
              label="Address*"
              placeholder="Address"
              id="address"
              name={`address`}
              innerRef={register({
                required: "Address is required",
              })}
              errors={errors}
            />
          </Col>
          <Col>
            <SikkaInput
              onBlur={(e) => {
                if (!e.target.value.trim()) {
                  setError(
                    e.target.name,
                    "custom",
                    `${CapitalizeString(
                      e.target.name
                    )} field should not have whitespace as value.`
                  );
                } else {
                  clearError(e.target.name);
                  setValue(e.target.name, e.target.value.trim());
                }
              }}
              label="City*"
              placeholder="City"
              id="city"
              name={`city`}
              innerRef={register({
                required: "City is required",
              })}
              errors={errors}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <SikkaInput
              onBlur={(e) => {
                if (!e.target.value.trim()) {
                  setError(
                    e.target.name,
                    "custom",
                    `${CapitalizeString(
                      e.target.name
                    )} field should not have whitespace as value.`
                  );
                } else {
                  clearError(e.target.name);
                  setValue(e.target.name, e.target.value.trim());
                }
              }}
              label="State*"
              placeholder="State"
              id="state"
              name={`state`}
              innerRef={register({
                required: "State is required",
              })}
              errors={errors}
            />
          </Col>
          <Col>
            <SikkaInput
              onBlur={(e) => {
                if (!e.target.value.trim()) {
                  setError(
                    e.target.name,
                    "custom",
                    `${CapitalizeString(
                      e.target.name
                    )} field should not have whitespace as value.`
                  );
                } else {
                  clearError(e.target.name);
                  setValue(e.target.name, e.target.value.trim());
                }
              }}
              label="Zip*"
              placeholder="Zip"
              id="zip"
              name={`zip`}
              innerRef={register({
                required: "Zip is required",
              })}
              errors={errors}
            />
          </Col>
        </Row>
        {!isApiPlusExist && <Row>
          <Col>
            <SikkaInput
              onBlur={(e) => {
                if (!e.target.value.trim()) {
                  setError(
                    e.target.name,
                    "custom",
                    `${CapitalizeString(
                      e.target.name
                    )} field should not have whitespace as value.`
                  );
                } else {
                  clearError(e.target.name);
                  setValue(e.target.name, e.target.value.trim());
                }
              }}
              label="Email Id*"
              placeholder="Email ID"
              id="email_id"
              name={`email_id`}
              innerRef={register({
                required: "Email is required",
                pattern: {
                  value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                  message: "Email must be valid",
                },
              })}
              errors={errors}
            />
          </Col>
        </Row>}
      </div>

      <div className="payment-notice p-2"
        style={{ background: "#f6ecfcff" }}>
        {!isApiPlusExist && <small>
          <b className="text-danger">Verification Notice :</b>
        </small>
        }
        <small className="custom-purple-text " >
          <p>
            To ensure the security of your payment method, we will process a
            temporary charge of $0.01 on your{" "}
            {defaultActiveKey == "ach" ? " account" : "Credit card"}.
            This amount will be immediately refunded to your account after
            verification. Thank you for your understanding.
          </p>
        </small>
      </div>

      <div
        className="mt-2"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {
          !isApiPlusExist && 
          <><Button
          size="sm"
          onClick={() => {
            if (step == 1) {
            } else {
              setStep(1);
            }
          }}
          disabled={step == 1 || isSubmitButtonClicked}
        >
          <FontAwesomeIcon icon={faLeftLong} /> {"  Previous"}
        </Button></>
        }
        <Button
          variant={!isApiPlusExist && "primary"}
          className={isApiPlusExist? "w-100 sai_button" : ""}
          size={"sm"}
          form={`${defaultActiveKey}-hook-form`}
          // type="submit"
          onClick={handleSubmit(HandlePaymentCardForm)}
          disabled={isSubmitButtonClicked}
        >
          Register
        </Button>
      </div>
    </>
  );
};

export default withRedirect(RegisterPayment);

export const CapitalizeString = (str) => {
  let customString = str.split(/_| /g);
  let output = "";

  customString.map((item, index) => {
    output += item.charAt(0).toUpperCase() + item.slice(1);
    if (index < customString.length - 1) {
      output += " ";
    }
  });

  return output;
};
